var addFallbackMediaMetaSlides,
    addIdToSlide,
    cleanupRelativeURLs,
    fallbackSlidesDe         = require("app/theme/styles/slides/fallback-slides.de.js"),
    fallbackSlidesEn         = require("app/theme/styles/slides/fallback-slides.en.js"),
    fallbackSlidesNl         = require("app/theme/styles/slides/fallback-slides.nl.js"),
    fallbackSlidesNotext     = require("app/theme/styles/slides/fallback-slides-notext.js"),
    get                      = require("object-path").get,
    repeatMediaMetaSlides,
    tallFallbackSlidesNotext = require("app/theme/styles/slides/tall-fallback-slides-notext.js"),
    utils                    = require("enyo/utils");

/**
 * Helper that inserts fallback slides if the media item does not have slides of
 * it's own.
 *
 * @param    {string}  language   The current application language
 * @param    {Object}  mediaItem  The media item
 * @returns  {Object}  The media item with fallback slides injected if needed
 */
module.exports = function(language, mediaItem) {

    // Add fallback slides as needed
    mediaItem = addFallbackMediaMetaSlides(language, mediaItem);

    // Repeat slides as needed
    mediaItem.meta        = mediaItem.meta || {
        slides: []
    };
    mediaItem.meta.slides = repeatMediaMetaSlides(mediaItem.meta.slides, 10);

    // Give a unique ID to all slides
    mediaItem.meta.slides.map(addIdToSlide);

    // Clean up relative urls
    mediaItem.meta.slides.map(cleanupRelativeURLs);

    return mediaItem;
};

/**
 * Helper that inserts fallback slides if the media item does not have slides of
 * it's own.
 *
 * @param    {string}  language   The current application language
 * @param    {Object}  mediaItem  The media item
 * @returns  {Object}  The media item with fallback slides injected if needed
 */
addFallbackMediaMetaSlides = function(language, mediaItem) {
    var numSlides = get(mediaItem, "meta.slides.length", 0);

    if (numSlides === 0) {
        if ([
            "audio",
            "book",
            "video"
        ].includes(mediaItem.type)) {
            mediaItem.meta.slides = tallFallbackSlidesNotext();
        }
        else if ([
            "artist_page",
            "magazine",
            "music_album",
            "playlist_page",
            "podcast",
            "series"
        ].includes(mediaItem.type)) {
            mediaItem.meta.slides = fallbackSlidesNotext();
        }
        else if ([
            "brand",
            "category",
            "page",
            "product_category",
            "product"
        ].includes(mediaItem.type)) {
            if (get(mediaItem, "show_meta_text", true)) {
                mediaItem.meta.slides = fallbackSlidesNotext();
            }
            else {
                switch (language) {
                    case "nl":
                        mediaItem.meta.slides = fallbackSlidesNl();
                        break;
                    case "de":
                        mediaItem.meta.slides = fallbackSlidesDe();
                        break;
                    case "en":
                    default:
                        mediaItem.meta.slides = fallbackSlidesEn();
                        break;
                }
            }
        }
    }

    return mediaItem;
};

/**
 * Repeat a set of slides to ensure a minimum total amount of slides is reached.
 *
 * @param    {Array}   slides  The current slides array
 * @param    {number}  target  The target amount
 * @returns  {Array}   The slides
 * @public
 */
repeatMediaMetaSlides = function(slides, target) {
    var repetitions,
        i,
        j,
        slide,
        serial_nr = 0,
        repeated  = [];

    // No repetition needed
    if (slides.length >= target || slides.length <= 1) {
        return slides;
    }

    repetitions = Math.ceil(target / slides.length);

    for (i = 0; i < repetitions; i++) {
        for (j = 0; j < slides.length; j++) {
            serial_nr++;
            slide           = utils.clone(slides[j]);
            slide.key       = get(slide, "key", "") + "_" + i;
            slide.serial_nr = serial_nr;
            repeated.push(slide);
        }
    }

    return repeated;
};

/**
 * Ensures a unique ID on the slide
 *
 * @param    {Object}  slide  The slide
 * @returns  {Object}  The slide with id
 */
addIdToSlide = function(slide) {
    slide.id = utils.uid();

    return slide;
};

/**
 * Make sure all relative urls have a leading slash and no trailing slash
 *
 * @param    {Object}  slide  The slide
 * @returns  {Object}  The slide with clean url
 */
cleanupRelativeURLs = function(slide) {
    // Find relative url
    if (typeof slide.link_to === "string"
            && slide.link_to !== ""
            && slide.link_to.substring(0, 4) !== "http") {
        // Add leading slash
        if (slide.link_to.substr(0, 1) !== "/") {
            slide.link_to = "/" + slide.link_to;
        }

        // Trim trailing slash
        if (slide.link_to.substr(-1) === "/") {
            slide.link_to = slide.link_to.substr(0, slide.link_to.length - 1);
        }
    }

    return slide;
};
